import React from 'react';

const typeStyles = {
  error: 'border-red-200 text-red-700',
  success: 'border-green-200 text-green-700',
  info: 'border-blue-200 text-blue-600',
};

const typeBackgrounds = {
  error: '#FEF2F2',
  success: '#ECFDF5',
  info: '#EFF6FF',
};

const ToastMessage = ({ toast, onClose }) => {
  if (!toast) return null;

  return (
    <div className="fixed top-4 right-4 z-[2147483647] max-w-sm">
      <div
        className={`rounded-2xl border px-4 py-3 text-sm shadow-card sm:text-base ${typeStyles[toast.type] || typeStyles.info}`}
        style={{
          opacity: 1,
          backgroundColor: typeBackgrounds[toast.type] || typeBackgrounds.info,
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
        }}
      >
        <div className="flex items-start justify-between gap-3">
          <p>{toast.message}</p>
          <button
            type="button"
            onClick={onClose}
            className="leading-none text-secondary-text transition hover:text-text"
            aria-label="Close notification"
          >
            x
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToastMessage;
